export const skills = [
  {
    title: "C++",
    color: "text-yellow-500",
  },
  {
    color: "text-yellow-500",
    title: "React JS",
  },
  {
    color: "text-yellow-500",
    title: "React Native",
  },
  {
    title: "Bootstrap",
  },
  {
    title: "HTML",
  },
  {
    title: "Next JS",
  },

  {
    title: "Adobe XD",
  },
  {
    title: "Tailwind",
    color: "text-yellow-500",
  },

  {
    title: "CSS",
  },
  {
    title: "GatsBy JS",
  },

  {
    color: "text-yellow-500",
    title: "React VR",
  },
  {
    title: "Material UI",
  },
  {
    title: "JavaScript",
    color: "text-yellow-500",
  },
  {
    title: "Firebase",
  },
  {
    title: "Canva",
  },
  {
    title: "Chakra UI",
  },
];
